import { IDynamicLinkedServiceTypeMetadata, ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { supportedMongoDbTypes } from 'app/registries/consts/tabular-consts';
import { atlasConnectionString, mongoDbDriverVersionOptions, mongoDbDriverVersion } from 'app/shared/utils/connector-metadata-static-consts';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';

export const mongoDbAtlasMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.mongoDbAtlas.linkedServiceType,
        displayName: stringResources.MongoDbAtlas_DisplayText,
        linkedServiceKind: 'hierarchical',
        icon: {
            className: 'svg-i-100x100-MongoDBAtlas'
        },
        tableNameAlias: 'collection',
        queryAlias: 'filter',
        isFirstClass: true,
        tableColumnNameQuotes: ['"', '"'],
        supportDatasetV2: true,
        supportedInTrident: true,
        supportCopyJobSource: true,
        supportCopyJobSink: true,
        supportedJobModesAsSource: GlobalVariables.copyJobIncrementalCopyPhase2 ? undefined : ['Batch'],
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'MongoDBAtlasForPipeline' as ResourceKind
        },
        supportOPDG: GlobalVariables.enableOPDG,
        copySinkTypes: [adfModelTypeMap.mongoDb.copySinkType],
        copySourceTypes: [adfModelTypeMap.mongoDbAtlas.copySourceType],
        category: ['NoSQL'],
        supportFirstClassParameterExperience: false,
        onetimeQueryTemplate: '{\n<<columnName>>: filterValue\n}',
        timedQueryTemplate: '{\n<<columnName>>: {\n$gte: ISODate(\'@{formatDateTime(pipeline().parameters.windowStart)}\'),\n$lt: ISODate(\'@{formatDateTime(pipeline().parameters.windowEnd)}\')}\n}',
        deltaLoadQueryTemplate: `{<<columnName>>: {
        $gte: @{if(contains(json(item().DataLoadingBehaviorSettings).watermarkColumnType, 'Int'),
            json(item().DataLoadingBehaviorSettings).watermarkColumnStartValue,
            concat('ISODate(''', formatDateTime(json(item().DataLoadingBehaviorSettings).watermarkColumnStartValue), ''')'))},
        $lt: @{if(contains(json(item().DataLoadingBehaviorSettings).watermarkColumnType, 'Int'),
            activity('GetMaxWatermarkValue').output.firstRow.CurrentMaxWaterMarkColumnValue,
            concat('ISODate(''', formatDateTime(activity('GetMaxWatermarkValue').output.firstRow.CurrentMaxWaterMarkColumnValue), ''')'))},
    }}`,
        linkedServiceNamePrefix: 'MongoDbAtlas',
        controls: [
            {
                type: 'radio',
                isLabelVertical: true,
                label: stringResources.DriverVersion,
                description: stringResources.MongoDb_DriverVersion_Description,
                escapeDescription: false,
                bind: 'driverVersion',
                options: mongoDbDriverVersionOptions,
                defaultValue: mongoDbDriverVersion.V2
            },
            {
                type: 'select-button-switch',
                required: true,
                isLabelVertical: true,
                options: [
                    {
                        label: stringResources.ModelName_ConnectionString,
                        value: false
                    },
                    {
                        label: stringResources.AzureKeyVault_DisplayText,
                        value: true
                    }
                ],
                bind: 'enableAKV',
                isNotRelatedToCredential: true,
                defaultValue: false,
                cases: [
                    {
                        caseValue: true,
                        children: [
                            {
                                type: 'azure-key-vault',
                                bind: 'referedAKV',
                                isLabelVertical: true,
                                description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template_ConnectionStringWithSample,
                                    format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MongoDbAtlas_DisplayText),
                                    atlasConnectionString)
                            },
                            {
                                type: 'textbox',
                                bind: 'databaseName',
                                label: stringResources.ModelName_DatabaseName,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        ]
                    },
                    {
                        caseValue: false,
                        children: [
                            {
                                type: 'mongo-db-select',
                                bind: {
                                    connectionString: 'connectionString',
                                    databaseName: 'databaseName'
                                },
                                mongoDbType: 'atlas' as supportedMongoDbTypes,
                                parameterizable: false,
                                validators: {
                                    connectionString: [
                                        { type: 'required', errorMessage: '' }
                                    ],
                                    databaseName: [
                                        { type: 'required', errorMessage: '' }
                                    ]
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return metadata;
}   
